<div class="ui-g">
  <div class="ui-g-12">
    <textarea
      class="input texto-cinza"
      style="width: 100%;"
      pInputTextarea
      autoResize="true">
    </textarea>
  </div>
</div>